module.exports = __webpack_public_path__ + "static/media/Possessive-Adjectives-in-Spanish.7ba92191.jpg";